import { render, staticRenderFns } from "./item_select.vue?vue&type=template&id=0b4ba184&"
import script from "./item_select.vue?vue&type=script&lang=js&"
export * from "./item_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports